/**
 * Tooltip component
 */

/** Dependencies -------------------------------------------- */

// External

import classNames from 'classnames'
import { Tooltip as ReactTooltip } from 'react-tooltip'

/** Main ---------------------------------------------------- */

const baseClassName = 'tooltip'

export default function Tooltip( props ) {

    const {
        className,
        children,
        ...additionalProps
    } = props

    const consolidatedClassName = classNames(
        baseClassName,
        className
    )

    return (
        <ReactTooltip className={ consolidatedClassName } { ...additionalProps }>
            { children }
        </ReactTooltip>
    )
}
